import React, { FC } from 'react';

import { useLocation } from 'react-router-dom';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';

import { RecordOptions } from '~/views/components/records/types';

import { componentSeasonSelectors } from '../../../redux/ducks/componentSeason';
import { RecordMap } from '../../../types/RecordCategoriesTypes';
import { ComponentSeasonTypes } from '../../../types/Types';
import { pageDepthCounter } from '../../../utils/formatter';
import Records from '../../components/records';

type Props = {
    isLoading: boolean;
    records: RecordMap;
    templateKey: string;
    options?: RecordOptions;
};

const BaseRecords: FC<Props> = ({ isLoading, records, templateKey, options }) => {
    const location = useLocation();
    const currentSeason = componentSeasonSelectors(ComponentSeasonTypes.Records).seasonId;

    if (Object.keys(records).length > 0) {
        const page = location.pathname;
        const count = pageDepthCounter(page);

        return (
            <LoadingDisplay isLoading={isLoading}>
                <Records
                    records={records}
                    templateKey={templateKey}
                    page={page}
                    pageLevel={count}
                    currentSeason={currentSeason}
                    options={options}
                />
            </LoadingDisplay>
        );
    } else {
        return (
            <LoadingDisplay isLoading={true}>
                <div className="loading">Loading...</div>
            </LoadingDisplay>
        );
    }
};

export default BaseRecords;
